import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../LinkyLinky';
import { ParticipantResource } from '../../../../../../../ParticipantsStore/Types';
import { Link } from '../../../../../../../Resource/Types';
import Modal from '../../../../../../Modal';
import ModalStore from '../../../../../../Modal/Store';
import AddParticipantStore from '../../../../Store';
import Body from './Body';
import Header from '../Header';
import { ParticipantState } from '../../../../Store/Types';

export interface Props {
  modalStore: ModalStore;
  links: ReadonlyArray<Link>;
  store: AddParticipantStore;
  newParticipants: ReadonlyArray<ParticipantResource>;
  state: ParticipantState;
}

const ReadyModal: React.FC<Props> = ({ links, modalStore, store, newParticipants, state }) =>
  findLink('participants', links)
    .map((link) => (
      <Modal
        close={modalStore.close}
        title={<Header />}
        customBackgroundCssClasses="bg-teal-100 opacity-60"
      >
        <Body state={state} link={link} store={store} newParticipants={newParticipants} />
      </Modal>
    ))
    .getOrElse(emptyFragment);

export default observer(ReadyModal);
